import { render } from "./ShortenTool.vue?vue&type=template&id=ff960f96&scoped=true"
import script from "./ShortenTool.vue?vue&type=script&lang=js"
export * from "./ShortenTool.vue?vue&type=script&lang=js"

import "./ShortenTool.vue?vue&type=style&index=0&id=ff960f96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff960f96"]])

export default __exports__